import { Badge, Box } from "@chakra-ui/react";
import { useState, useEffect } from "react";

const NewFeature = ({
  children,
  expiryDate = "2025-05-22",
  label = "New",
  badgeColor = "red",
  top = 2,
  right = 4,
}) => {
  const [isNew, setIsNew] = useState(false);

  useEffect(() => {
    const expiry = new Date(expiryDate);
    const today = new Date();
    setIsNew(!isNaN(expiry.getTime()) && expiry > today);
  }, [expiryDate]);

  return (
    <Box position="relative" display="inline-block">
      {children}
      {isNew && (
        <Badge
          colorScheme={badgeColor}
          fontSize="0.6em"
          position="absolute"
          top={top}
          right={right}
          transform="translate(50%, -50%)"
          px="1.5"
          py="0.5"
          borderRadius="md"
          fontWeight="bold"
          boxShadow="md"
        >
          {label}
        </Badge>
      )}
    </Box>
  );
};

export default NewFeature;
